import React from "react";
import { SprayCanIcon } from "lucide-react";
import { bonuses } from "../data/content";
const coverTones: Record<string, string> = {
  mint: "bg-mint text-ink",
  sun: "bg-sun text-ink",
  ink: "bg-ink text-cream"
};
export function BundleShowcase() {
  return <div className="mx-auto w-full max-w-md" role="group" aria-label="Contenido del paquete: ebook, 8 bonos y kit en el celular" data-id="element-82" data-mp="3q2vebpq4tqgm">
      <div className="flex items-end justify-center gap-4 sm:gap-6" data-id="element-83" data-mp="3pn8e65js77l">
        <figure className="w-[60%]" data-id="element-84" data-mp="7qp6gjnqad7z">
          <div className="relative flex aspect-[3/4] flex-col rounded-l-md rounded-r-2xl bg-ink p-5 text-cream shadow-[10px_14px_30px_-12px_rgba(18,40,60,0.55)] sm:p-6" data-id="element-85" data-mp="7pxjfx875ntb">
            <span className="absolute inset-y-0 left-0 w-2 rounded-l-md bg-black/25" aria-hidden="true" data-id="element-86" data-mp="homtx4xrk5zj" />
            <SprayCanIcon className="h-8 w-8 text-sun" aria-hidden="true" data-id="element-87" data-mp="2eheylukhbu75" />
            <p className="mt-auto font-display text-xl font-semibold leading-tight sm:text-2xl" data-id="element-88" data-mp="2ejhwt1vsctmy">
              De cero a tu empresa de limpieza
            </p>
            <span className="mt-4 block h-1 w-10 rounded-full bg-sun" aria-hidden="true" data-id="element-89" data-mp="2f7u6vfem1q9q" />
          </div>
          <figcaption className="mt-3 text-center text-sm font-bold text-ink" data-id="element-90" data-mp="2aesqf2yr9io1">Ebook · 189 páginas</figcaption>
        </figure>

        <figure className="w-[32%]" data-id="element-91" data-mp="25ewkuzaetj6d">
          <div className="flex aspect-[9/18] flex-col items-center justify-center rounded-[1.6rem] border-[5px] border-ink bg-white px-2 text-center shadow-[8px_12px_24px_-12px_rgba(18,40,60,0.5)]" data-id="element-92" data-mp="21ggpo846d4hv">
            <span className="font-display text-3xl font-semibold leading-none text-ink" data-id="element-93" data-mp="2t6li8u238xu6">27</span>
            <span className="mt-1 text-xs font-bold text-muted" data-id="element-94" data-mp="2p4qfdl4iecea">atajos</span>
          </div>
          <figcaption className="mt-3 text-center text-sm font-bold text-ink" data-id="element-95" data-mp="2k6oncap3v2qo">Kit en el celular</figcaption>
        </figure>
      </div>

      <div className="mt-8 flex flex-col items-center gap-4 rounded-2xl bg-white p-4 ring-1 ring-line sm:flex-row sm:p-5" data-id="element-96" data-mp="1dquv5xyqzdg7">
        <div className="flex shrink-0 -space-x-2" aria-hidden="true" data-id="element-97" data-mp="18t32h1qa3nay">
          {bonuses.map((b, i) => <span key={b.title} className={`flex h-11 w-8 items-center justify-center rounded-md text-sm font-extrabold ring-2 ring-white ${coverTones[b.tone]}`} data-id="element-98" data-mp="1a6ciiaqsoudq" data-mpi={i}>
              {i + 1}
            </span>)}
        </div>
        <div className="text-center sm:text-left" data-id="element-99" data-mp="157hqqjaunvhh">
          <p className="font-bold text-ink" data-id="element-100" data-mp="rhxr3mckfece">+ 8 bonos exclusivos</p>
          <p className="text-sm text-muted" data-id="element-101" data-mp="rfl1cn0kfzos">Guías prácticas en PDF</p>
        </div>
      </div>
    </div>;
}